import axios from "axios";
import React, { useEffect, useState } from "react";
import { baseUrl } from "./baseUrl";
import { toast } from "react-toastify";
import { translation } from "./Translation";

const Wallete = (props) => {
    const [det, setDet] = useState([]);
    const [lang, setLang] = useState(localStorage.getItem("lang") || "fa");

    let currency;
    if (typeof window !== "undefined") {
        currency = localStorage.getItem("currency");
    }
    useEffect(() => {
        let config = {
            url: `${baseUrl}/shops/${props.shop}/wallet`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setDet(res.data.data);
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || "خطا در دریافت اطلاعات کیف پول", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }, []);
    return (
        <div>
            <div className="wallet-main">
                <div className="wallet-modal">
                    <h2>
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M2 16.5V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V11C22 8.23858 19.7614 6 17 6H7C4.23858 6 2 8.23858 2 11V12"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                            <path
                                d="M19 6.5V6.33914C19 4.0991 16.944 2.42329 14.75 2.875V2.875L10.5 3.75L5.99174 4.67817C3.66769 5.15665 2 7.20267 2 9.57546L2 12"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                            />
                            <path
                                d="M6 17.5H12"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M22 16.5V17.25H22.75V16.5H22ZM18.5 12.25C18.9142 12.25 19.25 11.9142 19.25 11.5C19.25 11.0858 18.9142 10.75 18.5 10.75V12.25ZM21.25 11.5V16.5H22.75V11.5H21.25ZM22 15.75H17.5V17.25H22V15.75ZM17.5 12.25H18.5V10.75H17.5V12.25ZM17.5 15.75C16.5335 15.75 15.75 14.9665 15.75 14H14.25C14.25 15.7949 15.7051 17.25 17.5 17.25V15.75ZM15.75 14C15.75 13.0335 16.5335 12.25 17.5 12.25V10.75C15.7051 10.75 14.25 12.2051 14.25 14H15.75Z"
                                fill="#3BA7E4"
                            />
                            <path
                                d="M17.5 14H17.7"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>

                        {translation.Store_wallet[lang]
                            ? translation.Store_wallet[lang]
                            : "کیف پول"}
                    </h2>
                    <div className="alert">
                        <span className="span-1">
                            {translation.Store_Total[lang]
                                ? translation.Store_Total[lang]
                                : "کل سفارشات"}
                        </span>
                        <span>
                            {det &&
                                det.total_purchase &&
                                Number(
                                    det.total_purchase
                                ).toLocaleString()}{" "}
                            {currency && currency}
                        </span>
                    </div>

                    <div className="alert">
                        <span className="span-1">
                            {translation.Store_Creditor[lang]
                                ? translation.Store_Creditor[lang]
                                : "طلبکار از شرکت"}
                        </span>
                        <span>
                            {det && det.amount && det.status == "طلبکار"
                                ? Number(det.amount).toLocaleString()
                                : "0"}{" "}
                            {currency && currency}
                        </span>
                    </div>

                    <div className="alert">
                        <span className="span-1">
                            {" "}
                            {translation.Store_Indebted[lang]
                                ? translation.Store_Indebted[lang]
                                : "بدهکار به شرکت"}
                        </span>
                        <span>
                            {det && det.amount && det.status == "بدهکار"
                                ? Number(det.amount).toLocaleString()
                                : "0"}{" "}
                            {currency && currency}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Wallete;
